import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { requestData } from '@eggplant/data-request'

const url = `${AI_API_SERVICE}/usage_report`

export const getKeycloakUsageReportRequest = requestData(url, 'get', () => {}, () => {}, undefined, 'json', false)
